var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[(_vm.isList)?_c('list-items',{ref:"table",attrs:{"title":"Warehouse Inventory"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }